export const APPPERM = [
	{ code: 'project_read', label: 'Read Project'},
	{ code: 'project_modify', label: 'Modify Project'},
	{ code: 'project_file_read', label:'Read Project Files'},
	{ code: 'project_file_modify', label: 'Modify Project Files'},
	{ code: 'auth_read', label: 'Read Login User'},
	{ code: 'ws_push', label: 'Push Chat or Alarm'},
	{ code: 'group_read', label: 'Read Institute'},
	{ code: 'group_modify', label: 'Modify Institute'}
];

export const APPCATEGORY = [
    { value: 'app', label: 'Application' },
    { value: 'converter', label: 'Converter' },
    { value: 'util', label: 'Utility' },
    { value: 'productivity', label: 'Productivity' },
    { value: 'education', label: 'Education' },
    { value: 'etc', label: 'Etc' }
];
